import { gql } from '@apollo/client';

export const ALL_IMPACT_INDICATORS = gql`
  query AllImpactIndicators($impactId: ID!) {
    indicators: allImpactIndicators(impactId: $impactId) {
      id
      name
      definition
      unit
      measurementUnit
      dataCategory
    }
  }
`;
